<template>
  <div class="header">
    <p class="name">Tieyong Zeng</p>
    <p class="lang-switch" @click="changeLang">{{ lang === 'zh' ? 'English' : '中文' }}</p>
  </div>
</template>

<script>
// import langSelect from '@/components/langSelect/langSelect'
import { mapActions, mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      key: ''
    }
  },
  computed: {
    ...mapGetters(['lang', 'device']),
    ...mapState('common', ['companyInfo']),
    isPc() {
      return this.device === 'pc'
    }
  },
  methods: {
    ...mapActions('app', ['setLang']),
    changeLang() {
      const lang = this.lang === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = lang
      this.setLang(lang)
    },
    search() {
      this.$router.push({
        path: '/product/list',
        query: {
          key: this.key
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables.scss';
.header{
  padding: 8px 20px;
  display: flex;
  align-items: center;
  background-color: #f1f1f1;
  justify-content: space-between;
  .lang-switch{
    height: 16px;
    color: $mainColor;
    cursor: pointer;
    font-size: 14px;
    line-height: 16px;
    padding-left: 10px;
    white-space: nowrap;
    display: inline-block;
  }
}
</style>
